// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"f941a7e3","312":"31da2b89","415":"21708d98","675":"f6471c46","760":"74fea0b2","803":"ed7c86a4","813":"d52a686c","926":"949ff0dd","928":"16b8b371"}[chunkId] + ".chunk.css";
};